import React, { useState, useCallback, useRef } from 'react';
import { useRenderCount, useGlobalContext, TripType, hasFeatureFlag, FeatureFlagEnum, parseBoolean, } from '@honeycomb/data';
import { Button2, Container, EyeHideIcon, Paper, Styler, Tab2, Tabs2, TabsList, Switch, SwitchControlLabel, FlexGrid2, } from '@honeycomb/ui-core';
import { HotelHolidayFlightsSearchUnit } from './HotelHolidayFlightsSearchUnit';
import { useIntersect } from '../../utils/useIntersect';
export function Search({ state, action, tracking, reduced, sticky, expanded = true, onExpandSearch = (val) => val, showToggle = false, hotel, paperProps, }) {
    const { resourceStrings: { SEARCH_TABS_HOLIDAY_LABEL, SEARCH_TABS_HOTEL_LABEL, SEARCH_TABS_FLIGHT_LABEL, HC_SEARCH_SELECTED_HOTEL, }, configSettings: { HcSearchUnitOptions, HcDisplaySearchUnit, HCDestinationSearchToggle }, } = useGlobalContext();
    const HCDestinationSearchToggleConfig = parseBoolean(HCDestinationSearchToggle);
    const searchTabs = [{ key: TripType.Hotel, value: SEARCH_TABS_HOTEL_LABEL }];
    if (hasFeatureFlag(FeatureFlagEnum.FLIGHT_FUNNEL)) {
        searchTabs.unshift({ key: TripType.Flight, value: SEARCH_TABS_FLIGHT_LABEL });
    }
    if (HcSearchUnitOptions.includes(TripType.Holiday)) {
        searchTabs.unshift({ key: TripType.Holiday, value: SEARCH_TABS_HOLIDAY_LABEL });
    }
    const initalTabValue = searchTabs.length === 1 ? TripType.Hotel : state.tripType;
    // !! DEV-Only !! Counts and prints number of renders for component
    useRenderCount('Search');
    const [selectedTripType, setSelectedTripType] = useState(initalTabValue);
    const [isEstabSearch, setIsEstabSearch] = useState(true);
    const [searchError, setSearchError] = useState(false);
    const [inViewRef, entry] = useIntersect({ threshold: 0.2 });
    const searchElementRef = useRef(null);
    const onToggleChange = () => {
        setIsEstabSearch(!isEstabSearch);
    };
    const resetSelectedTriptype = useCallback(() => {
        setSelectedTripType(initalTabValue);
    }, [initalTabValue]);
    const onSearchErrorChange = useCallback((val) => {
        setSearchError(val);
    }, []);
    const HotelHolidayFlightsSearchUnitComponent = React.useMemo(() => (React.createElement(HotelHolidayFlightsSearchUnit, { state: state, action: action, tracking: tracking, reduced: reduced, sticky: sticky, expanded: expanded, onExpandSearch: onExpandSearch, showToggle: showToggle, hotel: hotel, selectedTripType: selectedTripType, resetSelectedTriptype: resetSelectedTriptype, isEstabSearch: isEstabSearch, searchElementRef: searchElementRef, entry: entry, onSearchErrorChange: onSearchErrorChange })), [
        action,
        searchElementRef,
        entry,
        expanded,
        hotel,
        onSearchErrorChange,
        isEstabSearch,
        onExpandSearch,
        reduced,
        resetSelectedTriptype,
        selectedTripType,
        showToggle,
        state,
        sticky,
        tracking,
    ]);
    if (parseBoolean(HcDisplaySearchUnit) === false) {
        return null;
    }
    const showEstabToggle = HCDestinationSearchToggleConfig &&
        (hotel === null || hotel === void 0 ? void 0 : hotel.estabId) &&
        (((state === null || state === void 0 ? void 0 : state.destinationIds) && state.destinationIds.length > 0) ||
            ((state === null || state === void 0 ? void 0 : state.destinations) && state.destinations.length > 1) ||
            ((state === null || state === void 0 ? void 0 : state.destinations) && state.destinations.length === 1 && state.destinations.every((d) => (d === null || d === void 0 ? void 0 : d.type) !== 1)));
    const withClose = reduced && expanded;
    const isTransfer = selectedTripType === TripType.Transfer;
    const WrapperComponent = withClose ? Container : Styler;
    return (React.createElement("div", { ref: (ref) => {
            inViewRef(ref);
            searchElementRef.current = ref;
        } },
        reduced && !expanded && HotelHolidayFlightsSearchUnitComponent,
        (!reduced || withClose) && (React.createElement(Paper, Object.assign({ p: withClose ? 3 : 4, py: withClose ? 3 : undefined, pt: withClose ? undefined : 1, pb: withClose ? undefined : searchError ? 2 : 4, border: withClose ? 2 : 0, pos: withClose ? 'relative' : undefined, bw: withClose ? '0 0 2px 0' : undefined, cornerStyle: withClose ? undefined : 'rounded', shadow: withClose ? undefined : 'm', btr: withClose ? 0 : undefined }, paperProps),
            React.createElement(WrapperComponent, null,
                React.createElement(Styler, { mb: 3 },
                    React.createElement(FlexGrid2, { container: true, alignItems: "center" },
                        React.createElement(FlexGrid2, { item: true, xs: "fill" },
                            React.createElement(Tabs2, { "aria-label": "Search panel tabs", onChange: (_e, value) => {
                                    setSelectedTripType(value);
                                }, value: selectedTripType, positioning: withClose ? 'default' : 'centered', size: "s" },
                                React.createElement(TabsList, null, searchTabs.map((tab) => (React.createElement(Tab2, { value: tab.key, key: tab.key, "data-id": "search-tab", "data-key": tab.key }, tab.value)))))),
                        withClose && (React.createElement(FlexGrid2, { item: true, xs: "hold" },
                            React.createElement(Button2, { onClick: () => onExpandSearch(false), icon: React.createElement(EyeHideIcon, null), size: "xs", variant: "outlined" }, "Hide"))))),
                showEstabToggle && (React.createElement(Styler, { mb: 2 },
                    React.createElement(SwitchControlLabel, { control: React.createElement(Switch, { id: "search-hotel-switch", onChange: onToggleChange, checked: isEstabSearch, size: "s" }), label: HC_SEARCH_SELECTED_HOTEL, placement: "start", LabelProps: { size: 's' }, "data-id": "search_selected_hotel" }))),
                isTransfer ? React.createElement("div", null) : HotelHolidayFlightsSearchUnitComponent)))));
}
